import FeedbackOutlined from '@mui/icons-material/FeedbackOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';

import { useFeedbackMode } from '~/client/contexts/feedback-mode-context';

interface Props {
  color: string;
  activeColor: string;
  placement?: 'top' | 'right';
}

export const FeedbackModeToggle: React.FC<Props> = ({
  color,
  activeColor,
  placement = 'top',
}) => {
  const { active, toggle } = useFeedbackMode();
  return (
    <Tooltip
      title={active ? 'Exit feedback mode' : 'Feedback mode'}
      arrow
      placement={placement}
    >
      <IconButton
        size="small"
        aria-label="Feedback mode"
        aria-pressed={active}
        data-feedback-ui="toggle"
        onClick={toggle}
        sx={{
          color: active ? activeColor : color,
          opacity: active ? 1 : 0.6,
          flexShrink: 0,
          '&:hover': { opacity: 1 },
        }}
      >
        <FeedbackOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default FeedbackModeToggle;
